export const UPDATE_EMAIL_VERIFICATION_ATTEMPT = 'UPDATE_EMAIL_VERIFICATION_ATTEMPT';
export const UPDATE_EMAIL_VERIFICATION_SUCCESS = 'UPDATE_EMAIL_VERIFICATION_SUCCESS';
export const UPDATE_EMAIL_VERIFICATION_FAILURE = 'UPDATE_EMAIL_VERIFICATION_FAILURE';
export const UPDATE_EMAIL_VERIFICATION_CLEAR = 'UPDATE_EMAIL_VERIFICATION_CLEAR';
